/**
 * Feature map for all products - supports both current and legacy variations
 * @todo: Update the pricing features, once settled and ready to shipped, see
 *        https://linear.app/ghost/issue/BAE-318/update-feature-lists-in-bma
 */
const productFeatures = {
    Starter: {
        current: [
            'Your own website',
            'Custom domain',
            'Email newsletter',
            'Simple design settings',
        ],
        legacy: ['1 staff user', 'Free, official Ghost themes', 'Standard built-in integrations'],
    },
    Publisher: {
        current: [
            '3 staff users',
            'Custom themes',
            '8,000+ integrations',
            'Paid subscriptions',
            'Advanced analytics',
        ],
    },
    Business: {
        current: [
            '15 staff users',
            'Priority support',
            'Higher usage limits',
            'Early access to features',
        ],
        legacy: ['Unlimited staff users', 'Advanced domain configs', '99.9% uptime SLA'],
    },
    // Special product
    Custom: {
        legacy: [
            'Unlimited staff users',
            'Advanced configurations',
            'Dedicated IP address',
            '99.9% uptime SLA',
            'Unlimited members',
        ],
    },
    // Legacy-only products
    Creator: {
        legacy: [
            '2 staff users',
            'Unlimited custom themes',
            '1,000+ Zapier integrations',
            'Build custom integrations',
        ],
    },
    Team: {
        legacy: ['5 staff users', 'Priority support', 'More business tools'],
    },
    Basic: {
        legacy: ['100k views/month', '2 staff users', 'Custom themes', 'Custom integrations'],
    },
    Standard: {
        legacy: ['500k views/month', '5 staff users', '8,000 members', 'Priority support'],
    },
};

export default productFeatures;
